import React, { useEffect, useState } from 'react';



import { Box, Button, ColumnLayout, Container, FormField, Link, Pagination, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import { mdiFileExcel, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { formatCurrency, setParameters } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { btnIconForm, ItemsMovement } from '../../resources/types';
import DRPicker from '../DRPicker';
import MPModal from '../MPModal';
import SelectPaging from '../selects/selectPaging';


interface TableMovementsProps {
    visible: boolean;
    filter?: boolean;
    refresh?: boolean;
    showRange?: boolean;
    showBalances?: boolean;
    showBalance?: boolean;
    showUser?: boolean;
    showReceipt?: boolean;
    showCharge?: boolean;
    showPayment?: boolean;
    excel?: boolean;
    movements: ItemsMovement[];
    onSelect?: (selectedRow: any) => void; // ← optional now
    onRefresh?: () => void; // ← optional now
    onRangeChange?: (startDate: string, endDate: string) => void; // ← optional now
    records?: number;
    dateFilter?: "PERIOD" | "RANGE" | "NONE";
    //onDismiss: () => void;
    //onConfirm: (selectedDate: string) => void;
}

const TableMovements: React.FC<TableMovementsProps> = ({
    visible,
    filter = true,
    showUser = true,
    showRange = true,
    showReceipt = false,
    showBalances = false,
    showBalance = false,
    showCharge = true,
    showPayment = true,

    excel = false,
    movements,
    onSelect,
    onRangeChange,
    onRefresh,
    records = 0,
    dateFilter = "RANGE",
    refresh = true
    //onDismiss,
    //onConfirm, 
}) => {

    //const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const { parameters, data } = useGlobalState();

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const [movementsExcel, setMovementsExcel] = useState<any[]>([]);
    const filtered: ItemsMovement[] = movements.filter((item) => {

        const normalize = (str: string | undefined | null) =>
            (str || "")
                .toString()
                .toLowerCase()
                .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

        const searchWords = normalize(filterValue).split(/\s+/).filter(Boolean);
        const text = normalize([item.displayName ?? "", item.RUT ?? "", item.data ?? "", item.accountPlan ?? "", (item.ammount ?? "").toString(), item.dateTransaction ?? "", (item.idMovement ?? "").toString(), (item.receipt ?? "").toString(), (item.idUser ?? "").toString()].join(" "));
        return searchWords.every((word) => text.includes(normalize(word)));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    useEffect(() => {
    }, [visible]);

    useEffect(() => {
        setCurrentPageIndex(1);
    }, [movements]);

    const exportToExcel = () => {
        // Convert JSON to worksheet

        let mExcel: any[] = (filtered.map((movement: ItemsMovement) => ({
            idMovement: movement.idMovement,
            idUser: movement.idUser,
            RUT: movement.RUT,
            Cuenta: movement.accountPlan,
            Cargo: movement.ammount >= 0 ? 0 : movement.ammount,
            Abono: movement.ammount < 0 ? 0 : movement.ammount,
            Saldo: movement.balance,
            Fecha: movement.dateTransaction,
            Glosa: movement.data,
            Usuario: movement.displayName,
            Comprobante: movement.receipt,
        })));
        const ws = XLSX.utils.json_to_sheet(mExcel);

        // Create a workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Movements");

        // Generate XLSX file and download
        XLSX.writeFile(wb, "movements.xlsx");
    };
    const exportTableToPDF = (data: any[], columns: string[]) => {
        const doc = new jsPDF();

        doc.text("Movements", 14, 10);

        autoTable(doc, {
            head: [columns],
            body: data.map(row => columns.map(col => row[col])),
        });

        doc.save("movements.pdf");
    };

    const totalCargos = movements.reduce((sum, item) => {
        if (item.ammount < 0) {
            return sum + Math.abs(item.ammount); // or: sum - item.ammount
        }
        return sum;
    }, 0);
    console.log(totalCargos)
    const totalAbonos = movements.reduce((sum, item) => {
        if (item.ammount > 0) {
            return sum + item.ammount;
        }
        return sum;
    }, 0);

    return (
        <>
            <Table
                variant="embedded"
                cellVerticalAlign='top'
                stickyHeader
                filter={
                    <>
                        <SpaceBetween direction='horizontal' size='xs'>
                            {dateFilter === "RANGE" && (

                                <DRPicker start={parameters.startDate} end={parameters.endDate}
                                    onConfirm={(startDate: string, endDate: string) => {
                                        if (startDate && endDate) {
                                            const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                            setParameters(updatedParameters);
                                        } else {
                                            const updatedParameters = { ...parameters, startDate: "", endDate: "", };
                                            setParameters(updatedParameters);
                                        }
                                    }}
                                />
                            )}
                            {dateFilter === "PERIOD" && (

                                <div style={{ width: 130 }}>
                                    <MPModal
                                        width={120}
                                        today prevMonth nextMonth
                                        end={new Date()}
                                        date={`${parameters.period}`}
                                        onConfirm={(date) => {
                                            setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                        }}
                                    />
                                </div>
                            )}
                            {filter ? (

                                <div style={{ width: 300 }}>
                                    <TextFilter countText={filterValue === "" ? `${movements.length} registros` : `${paginated.length}/${movements.length}`}
                                        filteringPlaceholder="Filtrar"
                                        filteringText={filterValue}
                                        onChange={({ detail }) => {
                                            setFilterValue(detail.filteringText);
                                            setCurrentPageIndex(1);
                                        }}
                                    />
                                </div>
                            ) : undefined}
                            {excel && (
                                <Button disabled={movements.length === 0} onClick={exportToExcel} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>
                            )}
                            {!!refresh && (!!filter || dateFilter !== "NONE") && (
                                <Button onClick={() => {
                                    setParameters({ ...parameters, dummy: new Date() })
                                    if (!!onRefresh)
                                        onRefresh();

                                }} style={{ root: btnIconForm }}><Icon path={mdiMagnify} size={1} /></Button>
                            )}
                        </SpaceBetween>
                    </>
                }
                footer=
                {showBalances && movements.length > 0 && (
                    <Container header={<h3>Resumen del periodo consultado</h3>}>
                        <ColumnLayout columns={4}>
                            <FormField label="Saldo inicial">
                                <Box variant="awsui-value-large">
                                    {formatCurrency(movements[movements.length - 1].balance, "CLP")}
                                </Box>
                            </FormField>
                            <FormField label="Cargos">
                                <Box variant="awsui-value-large">
                                    {formatCurrency(totalCargos, "CLP")}
                                </Box>
                            </FormField>
                            <FormField label="Abonos">
                                <Box variant="awsui-value-large">
                                    {formatCurrency(totalAbonos, "CLP")}
                                </Box>
                            </FormField>
                            <FormField label="Saldo final">
                                <Box variant="awsui-value-large">
                                    {formatCurrency(movements[0].balance, "CLP")}
                                </Box>
                            </FormField>
                        </ColumnLayout>
                    </Container>

                )}

                pagination={

                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                        {filtered.length > parameters.pageSize && (
                            <Pagination
                                currentPageIndex={currentPageIndex}
                                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                            />
                        )}

                        {movements.length > 0 && (
                            <SelectPaging onSelect={(pageSize) => {
                                setCurrentPageIndex(1);
                                setParameters({ ...parameters, pageSize: pageSize });
                            }} />
                        )}
                    </SpaceBetween>
                }
                columnDefinitions={[
                    {
                        id: "dateTransaction",
                        header: "ID/Fecha",
                        width: 120,
                        minWidth: 120,
                        cell: item => (

                            <FormField
                                label={
                                    !!onSelect ?
                                        <Link onClick={() => onSelect?.(item)}>{item.idMovement}</Link> : item.idMovement
                                }
                                constraintText={!!item?.receipt && item.receipt !== "0" ? `C:#${item.receipt}` : undefined}
                            >{item.dateTransaction}</FormField>
                        ),
                    },
                    ...(showUser
                        ? [
                            {
                                id: "idUser",
                                header: "Usuario",
                                cell: (item: ItemsMovement) => (
                                    <FormField
                                        label={item.displayName}
                                    />
                                ),
                            },
                        ]
                        : []),
                    ...(showReceipt
                        ? [
                            {
                                id: "receipt",
                                header: "Folio",
                                cell: (item: ItemsMovement) => (
                                    <FormField
                                        label={item?.receipt}
                                    />
                                ),
                            },
                        ]
                        : []),
                    {
                        id: "data",
                        header: "Glosa",
                        minWidth: 240,
                        cell: item => (

                            <FormField
                                description={item.accountPlan}
                                label={item.data}
                            />
                        )
                    },
                    ...(showCharge
                        ? [
                            {
                                id: "charge",
                                header: "Cargo",
                                cell: (item: ItemsMovement) => (
                                    <div style={{ float: "right" }}>

                                        {item.ammount < 0 ?
                                            formatCurrency(item.ammount, "CLP") : "---------"}

                                    </div>
                                )
                            },
                        ]
                        : []),
                    ...(showPayment
                        ? [
                            {
                                id: "debit",
                                header: "Abono",
                                cell: (item: ItemsMovement) => (
                                    <div style={{ float: "right" }}>
                                        {item.ammount > 0
                                            ? formatCurrency(item.ammount, "CLP") : "---------"}
                                    </div>
                                )
                            },
                        ]
                        : []),
                    ...(showBalance
                        ? [
                            {
                                id: "balance",
                                header: "Saldo",
                                cell: (item: ItemsMovement) => (
                                    <div style={{ float: "right" }}>
                                        {formatCurrency(item.balance, "CLP")}
                                    </div>
                                )
                            },
                        ]
                        : []),
                ]}
                trackBy="idMovement"
                items={paginated ?? []}
                empty={
                    <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                    >
                        <SpaceBetween size="m">
                            <b>Sin movimientos asociados</b>
                        </SpaceBetween>
                    </Box>
                }
            />
        </>
    );
};

export default TableMovements;